import { ReactNode } from "react";
import {
  ActionButtonOnTap,
  TabsGroupOnTabSwitch,
  FreeBetsOnChangeCallback,
  SwitchOnChange,
} from "@ppb/the-wall-common/types";
import { AlertOnClose, AlertProps } from "@ppb/the-wall-common/types/Alert.types";

export type SportsbookObbPlacePanelI18N = {
  oddsLabel: string;
  stakeLabel: string;
  totalReturns: string;
  multiples: string;
  additionalMultiples: string;
  singles: string;
  removeLabel: string;
  freeBetsLabel?: string;
  bonusAvailabilityLabel?: string;
  oddsMovementUp: string;
  oddsMovementDown: string;
  casts: string;
  eachWay: string;
  eachWaySubtitle?: string;
  betBuilder: string;
  multiBetBuilder: string;
  termsLabel?: string;
  termsLinkLabel?: string;
  freeBetsAlertRemoveLabel?: string;
  balanceAfterBet: string;
  voidBlurbText?: string;
  priceBoosts: string;
  tabAllTitle: string;
  tabBetBuildersTitle: string;
  tabMultiplesTitle: string;
  tabCastTitle: string;
  tabSinglesTitle: string;
  tabLotteriesTitle: string;
  betslipAriaTitle: string;
};

export type SportsbookObbPlacePanelNotifications = AlertProps[];

export enum BetslipSection {
  bbMulti = "bbMulti",
  betBuilders = "betBuilders",
  oneLineMultiple = "oneLineMultiple",
  multiLinesMultiples = "multiLinesMultiples",
  castBets = "castBets",
  singles = "singles",
}

export enum SportsbookObbPlacePanelContentLayout {
  ACCORDION = "ACCORDION",
  TABS = "TABS",
}

export type CardContent = {
  card: ReactNode;
  title: string;
  startsOpen: boolean;
  collapsable: boolean;
};

export type BetslipCards = {
  id: string;
  content: CardContent[];
};

export type BetslipCollapsableCards = {
  id: string;
  content: ReactNode[];
};

export type SportsbookPlacePanelCollapsableCardViewModel = {
  title: string;
  card: ReactNode;
  startsOpen: boolean;
  onToggle: SportsbookObbPlacePanelCallbacks["onCollapseToggle"];
};

export type CollapsablesStartsOpen = {
  [k in BetslipSection]: boolean;
};

export type SportsbookObbPlacePanelProps = {
  betslipCards?: BetslipCards[];
  isPanelDisabled?: boolean;
  isSummaryDisabled?: boolean;
  isFreeBetsSelected?: boolean;
  isFreeBetsDisabled?: boolean;
  isOddsBoosted?: boolean;
  isOddsMovementOn: boolean;
  showAcceptOddsMovementAlert: boolean;
  oddsMovementLabels: {
    message: string;
    detailMessage: string;
  };
  hasFreeBets?: boolean;
  hasCTALoading?: boolean;
  hasBonusAvailable?: boolean;
  totalReturns: string;
  totalOriginalReturns?: string;
  notifications?: ReactNode;
  hasPlaceError: boolean;
  isPlaceBlocked?: boolean;
  isPlaceDisabled: boolean;
  footerPrefix?: ReactNode;
  placeBtnLabel: React.ReactNode;
  placeBtnSecondaryLabel?: string | string[];
  placeBtnLoadingLabel?: string;
  reversePlaceBtnLabels?: boolean;
  isDesktop?: boolean;
  i18n: SportsbookObbPlacePanelI18N;
  secondaryButton?: ReactNode;
  termsUrl?: string;
  freeBetsAlertMessage?: string;
  isLoggedIn?: boolean;
  balanceAfterBet?: string;
  hasMarketBlurbs?: boolean;
  shouldFocusMultiple?: boolean;
  shouldFocusBetBuilder?: boolean;
  shouldFocusCastBet?: boolean;
  isSinglesFirst?: boolean;
};

export type SportsbookObbPlacePanelOnPlaceClick = ActionButtonOnTap;
export type SportsbookObbPlacePanelOnFreeBetsChange = FreeBetsOnChangeCallback;
export type SportsbookObbPlacePanelOnRemoveAllClick = () => void;

export type SportsbookObbPlacePanelCallbacks = {
  onFreeBetsChange?: SportsbookObbPlacePanelOnFreeBetsChange;
  onPlaceClick: SportsbookObbPlacePanelOnPlaceClick;
  onRemoveAllClick: SportsbookObbPlacePanelOnRemoveAllClick;
  onCollapseToggle?: (isOpen: boolean) => void;
  onTabSwitch?: TabsGroupOnTabSwitch;
  onFreeBetsRemovePress?: AlertOnClose;
  onOddsMovementPreferencesChange: SwitchOnChange;
};

export type SportsbookObbPlacePanelViewModel = SportsbookObbPlacePanelProps & SportsbookObbPlacePanelCallbacks;

export type MarketSelection = {
  selectionId: number;
  marketId: string;
};
